export const DEFAULT_GROUP_TYPE = 'employee'
export const GROUP_TYPES = [
  { value: 'employee', text: 'Employer' },
  { value: 'association', text: 'Association' },
  { value: 'trust', text: 'Trust' }
]
